import { SVGFC } from '@repo/toolkit/types'

const MapIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2996_53523)">
        <path
          d="M20.9959 19.7234L19.5818 11.9324C19.5677 11.8546 19.5195 11.7873 19.4503 11.7488L15.891 9.76917C15.8448 9.74344 15.7931 9.73321 15.7422 9.73715L16.3897 18.0906L16.368 18.1003L20.6277 20.0113C20.6624 20.0268 20.6992 20.0344 20.7359 20.0344C20.7939 20.0344 20.8515 20.0153 20.8987 19.9783C20.976 19.918 21.0134 19.8198 20.9959 19.7234Z"
          fill="#44C868"
        />
        <path
          d="M12.0004 11.6618L8.36013 9.76577C8.3165 9.74302 8.26812 9.73374 8.22049 9.73694C8.23311 9.73617 8.2458 9.73624 8.25838 9.73722L7.61084 18.0906L11.8922 20.0114C11.9268 20.0268 11.9636 20.0345 12.0004 20.0345V11.6618Z"
          fill="#44C868"
        />
        <path
          d="M8.25895 9.73715C8.20808 9.73321 8.1563 9.74344 8.1101 9.76914L4.55077 11.7488C4.48165 11.7872 4.43342 11.8545 4.41932 11.9323L3.00523 19.7234C2.98772 19.8198 3.02512 19.9179 3.10236 19.9783C3.14972 20.0153 3.2072 20.0344 3.26521 20.0344C3.30188 20.0344 3.33875 20.0268 3.37338 20.0113L7.60986 18.1107L8.25895 9.73715Z"
          fill="#4CE166"
        />
        <path
          d="M15.743 9.73682C15.708 9.73952 15.6733 9.74884 15.6412 9.76557L12.001 11.6616V20.0343H12.001C12.0378 20.0343 12.0747 20.0266 12.1092 20.0111L16.3906 18.0904L15.743 9.73682Z"
          fill="#4CE166"
        />
        <path
          d="M3.99088 14.2929L3.70361 15.8756L7.95732 13.6289L8.05607 12.3548L8.07245 12.1436L3.99088 14.2929Z"
          fill="#FFDB56"
        />
        <path
          d="M7.99549 13.1348L7.9572 13.6288L3.7035 15.8755L3.00523 19.7227C2.98772 19.8191 3.02512 19.9173 3.10236 19.9777C3.14972 20.0147 3.2072 20.0338 3.26521 20.0338C3.30188 20.0338 3.33875 20.0262 3.37338 20.0106L7.60986 18.1101L7.99549 13.1348Z"
          fill="#A8EEFC"
        />
        <path
          d="M11.9999 12.7059L8.07021 12.144L7.95508 13.6294L11.9989 19.7704V17.5374L9.58584 13.7377L11.9999 14.0265V12.7059Z"
          fill="#FFBB24"
        />
        <path
          d="M19.1688 11.5926L17.459 10.6416L15.8403 11.0198L15.8606 11.2812L15.9405 12.3125L19.1688 11.5926Z"
          fill="#FFBB24"
        />
        <path
          d="M16.0856 14.1652L15.9324 12.1877L15.8419 11.0205L12.0015 12.7063V14.0269L14.5101 12.936L16.0856 14.1652Z"
          fill="#FFDB56"
        />
        <path
          d="M20.996 19.7235L20.6408 17.7665L15.9419 12.313L16.0855 14.165L20.9044 19.9735C20.9776 19.9128 21.013 19.8175 20.996 19.7235Z"
          fill="#FFBB24"
        />
        <path
          d="M12.0174 3.96484C9.97964 3.96484 8.32178 5.62134 8.32178 7.65745C8.32178 8.91696 8.91975 10.2692 10.0991 11.6766C10.9654 12.7103 11.8198 13.3751 11.8558 13.4029C11.9034 13.4398 11.9604 13.4581 12.0174 13.4581C12.0745 13.4581 12.1315 13.4398 12.1791 13.4029C12.2151 13.3751 13.0695 12.7103 13.9357 11.6766C15.1151 10.2692 15.7131 8.917 15.7131 7.65745C15.713 5.62134 14.0552 3.96484 12.0174 3.96484ZM13.386 7.65742C13.386 8.41265 12.7733 9.02493 12.0174 9.02493C11.2615 9.02493 10.6488 8.41268 10.6488 7.65742C10.6488 6.90215 11.2615 6.28991 12.0174 6.28991C12.7733 6.28991 13.386 6.90219 13.386 7.65742Z"
          fill="#FF4A4A"
        />
        <path
          d="M12.0177 3.96484C11.8562 3.96484 11.6971 3.97532 11.541 3.9955C13.3545 4.22989 14.76 5.78271 14.76 7.65745C14.76 8.91696 14.162 10.2692 12.9826 11.6766C12.4256 12.3413 11.8738 12.8532 11.5411 13.1415C11.7258 13.3016 11.8433 13.393 11.8561 13.4029C11.9037 13.4398 11.9607 13.4581 12.0177 13.4581C12.0748 13.4581 12.1318 13.4398 12.1794 13.4029C12.2153 13.3751 13.0698 12.7103 13.936 11.6766C15.1154 10.2692 15.7134 8.917 15.7134 7.65745C15.7133 5.62134 14.0555 3.96484 12.0177 3.96484Z"
          fill="#E7343F"
        />
        <path
          d="M12.1092 20.011L13.7012 19.2967L12.001 17.5371V20.0341H12.001C12.0378 20.0341 12.0746 20.0265 12.1092 20.011Z"
          fill="#FFDB56"
        />
        <path
          d="M19.5828 11.9312C19.5687 11.8534 19.5205 11.7861 19.4514 11.7476L19.1712 11.5918L15.9429 12.3117L20.6417 17.7652L19.5828 11.9312Z"
          fill="#1EA4E9"
        />
        <path
          d="M12.0009 20.0339C12.0009 20.0339 12.0009 20.0339 12.0009 20.0339V19.77L7.95716 13.6289L7.61133 18.0901L11.8927 20.0108C11.9273 20.0263 11.9641 20.0339 12.0009 20.0339Z"
          fill="#1EA4E9"
        />
      </g>
      <defs>
        <clipPath id="clip0_2996_53523">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MapIcon
